const PauseIcon = () => {
  return (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="2.63158" height="15" rx="1.31579" />
      <rect x="5.52637" width="2.63158" height="15" rx="1.31579" />
    </svg>

  )
}

export default PauseIcon